module.exports = __webpack_public_path__ + "media/images/landing/ar/save_time-e49f5479d80fa354f50a8f1e3a5e75c8.webp";